var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Servicios/icon/heroicons/Outline/Property 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13 16.7324H12V12.7324H11M12 8.73242H12.01M21 12.7324C21 17.703 16.9706 21.7324 12 21.7324C7.02944 21.7324 3 17.703 3 12.7324C3 7.76186 7.02944 3.73242 12 3.73242C16.9706 3.73242 21 7.76186 21 12.7324Z",
    stroke: "#21272A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8626345ee571b6067348ed0166f955b0.svg";
export { ForwardRef as ReactComponent };